import React from 'react'
import PropTypes from 'prop-types'
import {TimelineMax} from 'gsap'
import MultiLangText from '../multilang/MultiLangText'




class CareersPopUp extends React.Component {


  constructor(){
    super()
    this.state = {
        open_tl: null,
        closing:false,
    }

    this.closePopUp = this.closePopUp.bind(this)
    this.disableHeader = this.disableHeader.bind(this)
    this.enableHeader = this.enableHeader.bind(this)
  }



  enableHeader(){
    document.querySelector('body').classList.remove('force-hide-header')
  }
  disableHeader(){
    document.querySelector('body').classList.add('force-hide-header')
  }

  setUpOpenAnimation(){

      let open_tl = new TimelineMax({repeat:0})

      //console.log("Play opening");

        open_tl.add(()=>{

          if(this.state.closing){
            this.state.open_tl.kill()
            this.state.open_tl.remove()
            this.setState({closing:false,open_tl:null})
            this.props.closePopUp();
              this.enableHeader();
          }else{
            this.disableHeader();
          }

        })
        open_tl.fromTo(this.refs.container, .5, {alpha:0},{alpha:1})
        open_tl.fromTo(this.refs.location, .5, {alpha:0},{alpha:1})
        open_tl.fromTo(this.refs.title, .5, {alpha:0},{alpha:1})
        open_tl.fromTo(this.refs.line, .5, {width:0},{width:60})
        open_tl.fromTo(this.refs.gradient, 2, {top:'-100%'},{top:'100%'})
        open_tl.fromTo(this.refs.applyOuter, .5 ,{alpha:0},{alpha:1})
        open_tl.fromTo(this.refs.applyInner, 1 ,{maxWidth:0},{maxWidth:200},'-=.3')
        open_tl.fromTo(this.refs.applyInner, .5 ,{alpha:0},{alpha:1},'-=.3')

        open_tl.add(()=>{
          this.enableHeader();
        })

        this.setState({open_tl})

        //open_tl.from(this.refs.col2, .5, {alpha:0},'-=.5')
        //open_tl.pause();

  }

  componentDidUpdate(prevProps,newState){
      //if((!prevProps.currentCareer && this.props.currentCareer)){
      //console.log('Open?',prevProps.open , this.props.open);
      if(!prevProps.open && this.props.open){
        this.setUpOpenAnimation()
      }
  }

  closePopUp(){

    this.setState({closing:true})
    this.state.open_tl.pause();
    this.state.open_tl.timeScale(3.5)
    this.state.open_tl.reverse();
  }

  render () {


      //console.log('CareersPopUp',this);






      if(this.props.currentCareer){

        let content = this.props.currentCareer;


        let col1 ={
          en: content.acf.job_description.col1,
          de: content.acf.job_description.col1_de,
          it: content.acf.job_description.col1_it,
          es: content.acf.job_description.col1_es,
          hu: content.acf.job_description.col1_hu
        }

         let col2 ={
          en: content.acf.job_description.col2,
          de: content.acf.job_description.col2_de,
          it: content.acf.job_description.col2_it,
          es: content.acf.job_description.col2_es,
          hu: content.acf.job_description.col2_hu
        }


        let title = {

            en: content.title.rendered,
            de: content.acf.title_de,
            it: content.acf.title_it,
            es: content.acf.title_es,
            hu: content.acf.title_hu
        }





      return (<div className={"career-pop-up "+(this.props.open?' open' : ' closed')} ref="container">

                  <div className="inner-career">
                      <div className="title">
                        <div className="location" ref="location" dangerouslySetInnerHTML={{__html:content.acf.location }}  />
                        <h2 ref="title" ><MultiLangText text={title} /></h2>
                        <div ref="line" className="line"  />
                      </div>
                      <div className="columns">
                        <div ref="col1" className="col1" ><MultiLangText text={col1} /></div>
                        <div ref="col2" className="col2" ><MultiLangText text={col2} /></div>
                        <div className="cover"><div ref="gradient" className="gradient" /></div>
                      </div>
                  </div>
                  <div className="close-button" ref="closeButton" onClick={this.closePopUp} >
                      <div className="close-line" ref="line1" />
                      <div className="close-line" ref="line2"  />
                  </div>

                  <div className="apply" ref="applyOuter"><span ref="applyInner"><a href={"mailto:"+content.acf.apply_email+"?subject="+content.title.rendered}><MultiLangText text={this.props.optionsData.data.apply_for_job} /></a></span></div>
              </div>)

      }else{
        return null
      }

  }
}



export default CareersPopUp;



// WEBPACK FOOTER //
// ./src/modules/pages/CareerPopUp.js